module.exports = __webpack_public_path__ + "static/media/icon-massEmail.9f34d025.svg";